// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__26KlQ","head":"Table_head__3JGkb","col":"Table_col__3NTtQ"};